import { render } from "./Default.vue?vue&type=template&id=5a9b1c30"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=5a9b1c30&lang=scss"

import exportComponent from "F:\\Projeler\\vuejs\\eticposdashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__